<template>
    <div id="gauge-chart">
        <v-chart :options="graph"/>
        <div @click="notify()" class="notification"><svg-icon type="mdi" :path="icons.info"></svg-icon></div>
    </div>
</template>

<script>

import ECharts from 'vue-echarts'
import 'echarts/lib/chart/gauge'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/tooltip'
import SvgIcon from '@jamescoyle/vue-icon'
import { mdiInformationSlabCircle } from '@mdi/js'

export default {
  name: 'gauge',
  components: {'v-chart': ECharts, SvgIcon},
  props: ['name','min','max','value','infoMessage'],

  data() {
    return {
      graph : {
        tooltip: {
          formatter: function (p) {
            const formatNumber = (value) => {
              if (value === null || value === undefined || value === '') return '';
              const num = Number(value);
              if (Number.isNaN(num)) return value;

              if (Number.isInteger(num)) return String(num).replace('.', ',');
              return num.toFixed(1).replace('.', ',');
            };

            const name = p?.name ?? p?.data?.name ?? '';
            const raw = p?.value ?? p?.data?.value;

            return `${name} : ${formatNumber(raw)}`;
          }
        },
        textStyle: {
          fontFamily: 'Gotham',
          color: '#888',
        },
        title: {
          text: this.name,
          textStyle: {
            fontSize: 13
          }
        },
        series: [
          {
            name: '',
            type: 'gauge',
            startAngle: 210,
            endAngle:-30,
            min: this.min,
            max: this.max,
            center: ['50%','60%'],
            axisLabel: {
              show: true,
              fontSize: '12px',
              padding: -12,
              formatter: function (value) {
                const formatNumber = (value) => {
                  if (value === null || value === undefined || value === '') return '';
                  const num = Number(value);
                  if (Number.isNaN(num)) return value;

                  if (Number.isInteger(num)) return String(num).replace('.', ',');
                  return num.toFixed(1).replace('.', ',');
                };
                return Number.isFinite(value) ? formatNumber(value) : value;
              }
            },
            title: {
              show: false,
            },
            axisTick: {
              show: false
            },
            axisLine: {
              lineStyle :{
                width: 12,
                color:[[0.2, '#91c7ae'], [0.8, '#63869e'], [1, '#c23531']],
              },

            },
            pointer: {
              width:4,
            },
            radius: '90%',
            splitNumber: 5,
            detail: {
              formatter: function (value) {
                const formatNumber = (value) => {
                  if (value === null || value === undefined || value === '') return '';
                  const num = Number(value);
                  if (Number.isNaN(num)) return value;

                  if (Number.isInteger(num)) return String(num).replace('.', ',');
                  return num.toFixed(1).replace('.', ',');
                };
                return Number.isFinite(value) ? formatNumber(value) : '-';
              },
              fontSize: 18,
              offsetCenter: [0, '60%']
            },
            data: [{value: this.value, name: this.name}]
          }
        ]
      },
      icons: {
        info: mdiInformationSlabCircle,
      },
    }
  },
  methods: {
    notify() {
      const exists = document.querySelector('.alert');
      if (exists) return;

      this.$notifications?.closeAll?.();

      const timeout = 4000;
      this.isShowing = true;

      this.$notify(
        {
          message: this.infoMessage,
          icon: 'add_alert',
          horizontalAlign: 'center',
          verticalAlign: 'top',
          type: 'default',
          timeout
        });
        
        const checker = setInterval(() => {
        const stillExists = document.querySelector('.alert');
        if (!stillExists) {
          clearInterval(checker);
          this.isShowing = false;
        }
      }, 100);
    },
    modifyChartInMobileView() {
      if (window.screen.width < 600) {
        this.graph.series[0].axisLine.lineStyle.width = 8;
        this.graph.series[0].axisLabel.padding = -18;
        this.graph.series[0].detail.fontSize = 18;
        this.graph.series[0].detail.offsetCenter = [0, '70%'];
        this.graph.series[0].center =  ['50%','52%'];
      }
    },
  },
  mounted(){
    this.modifyChartInMobileView();
  }
}
</script>
<style>
#gauge-chart{position: relative}
.notification{
    position:absolute;
    bottom:15%;
    cursor:pointer;

}
#gauge-chart .echarts { width: 100%; height: 200px !important;  /* or e.g. 400px */ }

</style>